import { ProgressBar } from '@crehana/compass.ui/v2'; // Importing the ProgressBar component

// Type definition for the props of the ProgressSection component
type TProgressSection = {
  progress: number; // Progress percentage (0-100)
  label: string; // Label to display for the progress section
};

// Functional component to display a progress section with a label and progress bar
export const ProgressSection: React.FC<TProgressSection> = ({
  progress,
  label,
}) => {
  return (
    <div className="tw-flex tw-flex-col">
      {/* Wrapper for the whole section */}
      <p className="tw-font-link1 tw-text-neutral-light-800 tw-font-semibold">
        {/* Label for the section */}
        {label} {/* Displays the label */}
      </p>
      <div className="tw-mt-1.2 tw-flex tw-flex-row tw-items-center tw-gap-1.2 tw-w-auto tw-max-w-[30rem]">
        {/* Container for progress bar and percentage */}
        <ProgressBar value={progress} className="tw-rounded-2.4 tw-w-full" />
        {/* Progress bar component with dynamic progress */}
        {/* Displaying the progress percentage */}
        <span className="tw-text-neutral-light-700 tw-font-body5">{`${progress}%`}</span>
      </div>
    </div>
  );
};
